import { render, staticRenderFns } from "./UTT.vue?vue&type=template&id=7b42a872&"
import script from "./UTT.vue?vue&type=script&lang=js&"
export * from "./UTT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports